import { createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold");
  return _openBlock(), _createElementBlock("div", null, [$props.typedata && $props.typedata.length > 0 && parseInt($props.typemodel) < 4 ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(["typenav", [{
      'active': $props.elemName === 'typenav'
    }, `navulmodel${$props.typemodel}`, {
      'mobile': $props.ispc
    }, {
      'on': $props.ispc && $props.typemodel === '3' && !$data.showorhide
    }, `fid${$data.fid}`]]),
    style: _normalizeStyle($props.jsonOption.typenav),
    onClick: _cache[2] || (_cache[2] = $event => $options.styleHandle('typenav'))
  }, [_withDirectives(_createElementVNode("li", {
    class: _normalizeClass(["icon-typebg1", {
      'on': $props.currentType === 0
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.typeselect({
      value: '全部'
    }, _ctx.index)),
    style: _normalizeStyle($data.isupdate && $props.currentType === 0 ? $data.lifocus : $data.linormal)
  }, _cache[9] || (_cache[9] = [_createElementVNode("span", null, "全部", -1)]), 6), [[_vShow, _ctx.$route.query.fid !== '7877']]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typedata, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["icon-typebg1", [{
        'on': $props.currentType === index + 1
      }, {
        'long': item.value.length > 8
      }]]),
      key: index,
      onClick: $event => $options.typeselect(item, index),
      style: _normalizeStyle($data.isupdate && $props.currentType === index + 1 ? $data.lifocus : $data.linormal)
    }, [_createElementVNode("span", null, _toDisplayString(item.value), 1)], 14, _hoisted_1);
  }), 128)), _withDirectives(_createElementVNode("li", {
    class: _normalizeClass(["btnhandle icon-typebg1", `btntype${$props.typemodel}`]),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.btnHandle && $options.btnHandle(...args))
  }, [_createElementVNode("span", null, _toDisplayString(!$data.showorhide ? '分类展开' : '收起'), 1)], 2), [[_vShow, $props.typemodel === '3']])], 6)) : _createCommentVNode("", true), $props.typedata && $props.typedata.length > 0 && parseInt($props.typemodel) === 4 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["typenav", [{
      'active': $props.elemName === 'typenav'
    }, `navulmodel${$props.typemodel}`, {
      'mobile': $props.ispc
    }, {
      'on': !$data.showorhide
    }, `fid${$data.fid}`]]),
    style: _normalizeStyle($props.jsonOption.typenav),
    onClick: _cache[5] || (_cache[5] = $event => $options.styleHandle('typenav'))
  }, [_createElementVNode("div", {
    class: "titlebox",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.btnHandle && $options.btnHandle(...args))
  }, [_createElementVNode("span", null, _toDisplayString($data.currentTypeTitle), 1), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
    _: 1
  }, 512), [[_vShow, $data.showorhide]]), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowUpBold)]),
    _: 1
  }, 512), [[_vShow, !$data.showorhide]])]), _createElementVNode("ul", null, [_createElementVNode("li", {
    class: _normalizeClass(["icon-typebg1", {
      'on': $props.currentType === 0
    }]),
    onClick: _cache[4] || (_cache[4] = $event => $options.typeselect({
      value: '全部'
    }, _ctx.index)),
    style: _normalizeStyle($data.isupdate && $props.currentType === 0 ? $data.lifocus : $data.linormal)
  }, _cache[10] || (_cache[10] = [_createElementVNode("span", null, "全部", -1)]), 6), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typedata, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["icon-typebg1", [{
        'on': $props.currentType === index + 1
      }, {
        'long': item.value.length > 8
      }]]),
      key: index,
      onClick: $event => $options.typeselect(item, index),
      style: _normalizeStyle($data.isupdate && $props.currentType === index + 1 ? $data.lifocus : $data.linormal)
    }, [_createElementVNode("span", null, _toDisplayString(item.value), 1)], 14, _hoisted_2);
  }), 128))])], 6)) : _createCommentVNode("", true), $props.typedata && $props.typedata.length > 0 && parseInt($props.typemodel) === 5 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["typenav", [{
      'active': $props.elemName === 'typenav'
    }, `navulmodel${$props.typemodel}`, {
      'mobile': $props.ispc
    }, {
      'on': $data.showorhide
    }, `fid${$data.fid}`]]),
    style: _normalizeStyle($props.jsonOption.typenav),
    onClick: _cache[8] || (_cache[8] = $event => $options.styleHandle('typenav'))
  }, [_createElementVNode("div", {
    class: "titlebox",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.btnHandle && $options.btnHandle(...args))
  }), _createElementVNode("ul", null, [_createElementVNode("li", {
    class: _normalizeClass({
      'on': $props.currentType === 0
    }),
    onClick: _cache[7] || (_cache[7] = $event => $options.typeselect({
      value: '全部'
    }, _ctx.index)),
    style: _normalizeStyle($data.isupdate && $props.currentType === 0 ? $data.lifocus : $data.linormal)
  }, _cache[11] || (_cache[11] = [_createElementVNode("span", null, "全部", -1)]), 6), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typedata, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([{
        'on': $props.currentType === index + 1
      }, {
        'long': item.value.length > 8
      }]),
      key: index,
      onClick: $event => $options.typeselect(item, index),
      style: _normalizeStyle($data.isupdate && $props.currentType === index + 1 ? $data.lifocus : $data.linormal)
    }, [_createElementVNode("span", null, _toDisplayString(item.value), 1)], 14, _hoisted_3);
  }), 128))])], 6)) : _createCommentVNode("", true)]);
}